import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-slate-50 px-4 py-5" }
const _hoisted_2 = { class: "mx-auto max-w-[1700px] space-y-4" }
const _hoisted_3 = { class: "flex flex-col gap-4 rounded-md border border-slate-200 bg-white px-4 py-3 shadow-sm lg:flex-row lg:items-center lg:justify-between" }
const _hoisted_4 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = { class: "overflow-x-auto pb-2" }
const _hoisted_7 = { class: "min-w-[960px] rounded-md" }
const _hoisted_8 = { class: "grid grid-cols-4 gap-3" }
const _hoisted_9 = { class: "min-w-0" }
const _hoisted_10 = { class: "truncate text-sm font-semibold text-slate-950" }
const _hoisted_11 = { class: "truncate text-xs text-slate-500" }
const _hoisted_12 = { class: "ml-3 flex shrink-0 items-center gap-3" }
const _hoisted_13 = { class: "rounded-full bg-slate-100 px-2 py-0.5 text-xs font-semibold text-slate-700" }
const _hoisted_14 = { class: "mt-3 grid grid-cols-4 gap-3" }
const _hoisted_15 = { class: "max-h-[760px] space-y-2 overflow-y-auto p-3" }
const _hoisted_16 = {
  key: 0,
  class: "mb-2 flex justify-end"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "mt-1 truncate text-xs font-medium text-slate-600" }
const _hoisted_19 = {
  key: 1,
  class: "mt-1 flex min-w-0 flex-wrap items-center gap-y-1 text-[11px] text-slate-400",
  "aria-label": "Job details"
}
const _hoisted_20 = {
  key: 0,
  class: "mx-2 text-slate-300",
  "aria-hidden": "true"
}
const _hoisted_21 = ["title"]
const _hoisted_22 = { class: "max-w-[150px] truncate" }
const _hoisted_23 = { class: "mt-3 flex items-center justify-between gap-2 text-xs text-slate-500" }
const _hoisted_24 = {
  key: 0,
  class: "shrink-0 rounded-full bg-slate-100 px-2 py-0.5"
}
const _hoisted_25 = {
  key: 2,
  class: "mt-2 rounded bg-amber-50 px-2 py-1 text-xs font-medium text-amber-800"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "mt-3 flex items-center justify-between gap-2" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "flex gap-1.5" }
const _hoisted_30 = ["href"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  key: 4,
  class: "mt-3 border-t border-slate-100 pt-2"
}
const _hoisted_36 = { class: "flex flex-wrap gap-1" }
const _hoisted_37 = {
  key: 0,
  class: "py-8 text-center text-sm text-slate-400"
}
const _hoisted_38 = { class: "flex items-center justify-between border-b border-slate-200 px-5 py-4" }
const _hoisted_39 = { class: "p-5" }
const _hoisted_40 = { class: "w-full border-collapse text-sm" }
const _hoisted_41 = { class: "py-2.5 pr-4 text-left font-medium text-slate-600" }
const _hoisted_42 = { class: "py-2.5 text-right font-semibold text-slate-950" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_button = _resolveComponent("base-button")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_DatePickerModal = _resolveComponent("DatePickerModal")!
  const _component_JobDetailModal = _resolveComponent("JobDetailModal")!
  const _component_SkillsSetupModal = _resolveComponent("SkillsSetupModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _cache[10] || (_cache[10] = _createElementVNode("div", null, [
          _createElementVNode("p", { class: "text-xs font-semibold uppercase tracking-wide text-brand-700" }, "Application Tracker"),
          _createElementVNode("h1", { class: "text-xl font-semibold text-slate-950" }, "All Jobs")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_base_button, {
            type: "button",
            text: "Add",
            onClick: $setup.addNewJob
          }, null, 8, ["onClick"]),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showInsights = true)),
            class: "inline-flex h-10 items-center gap-2 rounded-md border border-slate-300 bg-white px-3 text-sm font-medium text-slate-700 hover:border-brand-300 hover:text-brand-700"
          }, [
            _createVNode(_component_font_awesome_icon, { icon: "chart-simple" }),
            _cache[8] || (_cache[8] = _createTextVNode(" Insights "))
          ]),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.refresh && $setup.refresh(...args))),
            class: "inline-flex h-10 w-10 items-center justify-center rounded-md border border-slate-300 bg-white text-slate-600 hover:border-brand-300 hover:text-brand-700",
            title: "Refresh"
          }, [
            _createVNode(_component_font_awesome_icon, { icon: "sync-alt" })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_font_awesome_icon, {
              icon: "search",
              class: "absolute left-3 top-3 text-xs text-slate-400"
            }),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.companySearch) = $event)),
              placeholder: "Search company or title",
              class: "h-10 w-64 rounded-md border border-slate-300 bg-white pl-8 pr-8 text-sm focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
            }, null, 512), [
              [_vModelText, $setup.companySearch]
            ]),
            ($setup.companySearch)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.resetCompanyFilter && $setup.resetCompanyFilter(...args))),
                  class: "absolute right-2 top-2 h-6 w-6 rounded text-slate-400 hover:bg-slate-100 hover:text-slate-700",
                  title: "Clear search"
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: "times" })
                ]))
              : _createCommentVNode("", true)
          ]),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.selectedRange) = $event)),
            class: "h-10 rounded-md border border-slate-300 bg-white px-3 text-sm text-slate-700 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
          }, _cache[9] || (_cache[9] = [
            _createElementVNode("option", { value: "30" }, "Last 30 days", -1),
            _createElementVNode("option", { value: "90" }, "Last 90 days", -1),
            _createElementVNode("option", { value: "180" }, "Last 6 months", -1),
            _createElementVNode("option", { value: "all" }, "All time", -1)
          ]), 512), [
            [_vModelSelect, $setup.selectedRange]
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.boardColumns, (column, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `rail-${column.key}`,
                class: _normalizeClass(["flex h-16 items-center justify-between rounded-md border border-t-2 border-slate-200 bg-white px-4 shadow-sm", column.railClass])
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("h2", _hoisted_10, _toDisplayString(column.label), 1),
                  _createElementVNode("p", _hoisted_11, _toDisplayString(column.shortDescription), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(column.jobs.length), 1),
                  (index < $setup.boardColumns.length - 1)
                    ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 0,
                        icon: "chevron-right",
                        class: "text-slate-300"
                      }))
                    : _createCommentVNode("", true)
                ])
              ], 2))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.boardColumns, (column) => {
              return (_openBlock(), _createElementBlock("div", {
                key: column.key,
                class: "min-h-[660px] rounded-md border border-slate-200 bg-white shadow-sm"
              }, [
                _createElementVNode("div", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(column.jobs, (job) => {
                    return (_openBlock(), _createElementBlock("article", {
                      key: `${column.key}-${job.id}`,
                      class: "rounded-md border border-slate-200 bg-white p-3 transition hover:border-brand-200 hover:shadow-sm"
                    }, [
                      (column.key !== 'applied' && job.latest_status)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["inline-flex max-w-full rounded-full px-2 py-0.5 text-right text-[11px] font-medium leading-tight", $setup.statusBadgeClass(job.latest_status)])
                            }, _toDisplayString(job.latest_status), 3)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", null, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => ($setup.openJobModal(job.id)),
                          class: "w-full min-w-0 text-left text-sm font-semibold leading-snug text-slate-950 hover:text-brand-700"
                        }, _toDisplayString(job.title), 9, _hoisted_17)
                      ]),
                      _createElementVNode("p", _hoisted_18, _toDisplayString(job.company), 1),
                      ($setup.cardMetadata(job).length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cardMetadata(job), (item, itemIndex) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: item.key
                              }, [
                                (itemIndex > 0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, "|"))
                                  : _createCommentVNode("", true),
                                _createElementVNode("span", {
                                  class: "inline-flex min-w-0 items-center",
                                  title: item.value
                                }, [
                                  _createVNode(_component_font_awesome_icon, {
                                    icon: item.icon,
                                    class: "mr-1 shrink-0 text-[10px] text-slate-400"
                                  }, null, 8, ["icon"]),
                                  _createElementVNode("span", _hoisted_22, _toDisplayString(item.value), 1)
                                ], 8, _hoisted_21)
                              ], 64))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("span", null, _toDisplayString($setup.stageAgeLabel(job)), 1),
                        ($setup.skillMatchLabel(job))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString($setup.skillMatchLabel(job)), 1))
                          : _createCommentVNode("", true)
                      ]),
                      ($setup.attentionLabel(job))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString($setup.attentionLabel(job)), 1))
                        : _createCommentVNode("", true),
                      ($setup.shouldOfferClose(job))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 3,
                            onClick: ($event: any) => ($setup.closeStaleJob(job.id)),
                            class: "mt-2 w-full rounded border border-amber-200 bg-white px-2 py-1.5 text-xs font-semibold text-amber-800 hover:bg-amber-50"
                          }, " Close as not selected ", 8, _hoisted_26))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => ($setup.toggleSkills(job.id)),
                          class: "text-xs font-medium text-slate-400 hover:text-brand-700"
                        }, " Skills ", 8, _hoisted_28),
                        _createElementVNode("div", _hoisted_29, [
                          (job.job_url)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: job.job_url,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                class: "inline-flex h-7 w-7 items-center justify-center rounded border border-slate-200 text-xs text-slate-500 hover:bg-slate-50 hover:text-brand-600",
                                title: "Open job posting"
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: "external-link" })
                              ], 8, _hoisted_30))
                            : _createCommentVNode("", true),
                          (column.key === 'matched')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                onClick: ($event: any) => ($setup.applyToFoundJob(job.id)),
                                class: "inline-flex h-7 w-7 items-center justify-center rounded border border-slate-200 text-xs text-slate-500 hover:bg-emerald-50 hover:text-emerald-700",
                                title: "Mark as applied"
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: "check" })
                              ], 8, _hoisted_31))
                            : (!$setup.isClosed(job))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 2,
                                  onClick: ($event: any) => ($setup.setInterview(job.id)),
                                  class: "inline-flex h-7 w-7 items-center justify-center rounded border border-slate-200 text-xs text-slate-500 hover:bg-emerald-50 hover:text-emerald-700",
                                  title: "Add next step"
                                }, [
                                  _createVNode(_component_font_awesome_icon, { icon: "plus" })
                                ], 8, _hoisted_32))
                              : _createCommentVNode("", true),
                          (column.key === 'matched')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 3,
                                onClick: ($event: any) => ($setup.dismissFoundJob(job.id)),
                                class: "inline-flex h-7 w-7 items-center justify-center rounded border border-slate-200 text-xs text-slate-500 hover:bg-rose-50 hover:text-rose-600",
                                title: "Dismiss"
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: "times" })
                              ], 8, _hoisted_33))
                            : (!$setup.isClosed(job))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 4,
                                  onClick: ($event: any) => ($setup.rejectJob(job.id)),
                                  class: "inline-flex h-7 w-7 items-center justify-center rounded border border-slate-200 text-xs text-slate-500 hover:bg-rose-50 hover:text-rose-600",
                                  title: "Reject"
                                }, [
                                  _createVNode(_component_font_awesome_icon, { icon: "times" })
                                ], 8, _hoisted_34))
                              : _createCommentVNode("", true)
                        ])
                      ]),
                      ($setup.expandedSkills[job.id] && $setup.cardSkills(job).length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                            _createElementVNode("div", _hoisted_36, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cardSkills(job), (skill) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: skill.skill_name || skill.id,
                                  class: _normalizeClass([
                          'rounded-full px-2 py-0.5 text-xs',
                          skill.user_has_skill ? 'bg-brand-50 text-brand-700' : 'bg-slate-50 text-slate-500',
                        ])
                                }, _toDisplayString(skill.skill_name), 3))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128)),
                  (column.jobs.length === 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString(column.empty), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    ($setup.showInsights)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 p-4",
          onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.showInsights = false))
        }, [
          _createElementVNode("div", {
            class: "w-full max-w-2xl rounded-md bg-white shadow-xl",
            onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", _hoisted_38, [
              _cache[11] || (_cache[11] = _createElementVNode("div", null, [
                _createElementVNode("h2", { class: "text-lg font-semibold text-slate-950" }, "Pipeline Insights"),
                _createElementVNode("p", { class: "text-xs text-slate-500" }, "Based on the current filters.")
              ], -1)),
              _createElementVNode("button", {
                class: "text-slate-400 hover:text-slate-700",
                onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.showInsights = false))
              }, [
                _createVNode(_component_font_awesome_icon, { icon: "times" })
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("table", _hoisted_40, [
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.insightRows, (row) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: row.label,
                      class: "border-b border-slate-100 last:border-b-0"
                    }, [
                      _createElementVNode("th", _hoisted_41, _toDisplayString(row.label), 1),
                      _createElementVNode("td", _hoisted_42, _toDisplayString(row.value), 1)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_DatePickerModal, {
      "is-open": $setup.isDatePickerOpen,
      onClose: $setup.closeDatePicker,
      statuses: $setup.statuses,
      onDateSelected: $setup.handleDateSelected
    }, null, 8, ["is-open", "onClose", "statuses", "onDateSelected"]),
    ($setup.selectedJob)
      ? (_openBlock(), _createBlock(_component_JobDetailModal, {
          key: 1,
          job: $setup.selectedJob,
          "is-open": $setup.isJobModalOpen,
          "user-skills": $setup.skills,
          statuses: $setup.statuses,
          onClose: $setup.closeJobModal,
          onStatusUpdated: $setup.onJobStatusUpdated,
          onSkillAdded: $setup.onJobSkillAdded
        }, null, 8, ["job", "is-open", "user-skills", "statuses", "onClose", "onStatusUpdated", "onSkillAdded"]))
      : _createCommentVNode("", true),
    ($setup.showSkillsModal)
      ? (_openBlock(), _createBlock(_component_SkillsSetupModal, { key: 2 }))
      : _createCommentVNode("", true)
  ]))
}